import React, { Component, Fragment } from 'react'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty';
import NumberFormat from 'react-number-format'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

// CSS
import '../../../css/display-table.css'

class TopSellers extends Component {
    constructor(props){
        super(props)
        this.state = {
            data: null,
            error: '',
            date_status: false,
            start_date: null,
            end_date: null,
            exporting: false,
            exportedFile: ""
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        const endpoint = "summary/top-sellers?order=" + this.props.sort + "&start=" + this.state.start_date + "&end=" + this.state.end_date;

        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
        return axios.get(REACT_APP_API_URL + endpoint, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200){
                this.setState({ error: response.data.message })
            }else{
                this.setState({ data: { ...response.data } })
            }
		})
		.catch((err) => {
			this.setState({ error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
		})
    }

    toggleDateInputs = () => {
        const { date_status } = this.state;

        if(date_status){
            this.setState({ 
                date_status: !date_status,
                start_date: null,
                end_date: null,
                exportedFile: ""
            }, () => this.loadData())
        } else {
            this.setState({ date_status: !date_status })
        }
    }

    handleInputChange = (value, type) => {
        const { start_date, end_date } = this.state;
        this.setState({
            [type]: value
        }, 
        () => {
            if(type === 'start_date'){
                if(end_date !== null) this.loadData();
            } else if (type === 'end_date'){
                if(start_date !== null) this.loadData();
            }
        }
        )
    }

    exportData = () => {
        this.setState({
            exporting: true,
            exportedFile: ""
        }, () => {
            const item = {
                data: this.state.data,
                type: this.props.sort === 'revenue' ? 'total_purchased' : 'times_purchased',
                start_date: this.state.start_date,
                end_date: this.state.end_date
            }
    
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
            return axios
            .post(REACT_APP_API_URL + "summary", item, { headers: AUTH_HEADER })
            .then((response) => {
                console.log(response);
                if(response.status !== 200){
                    this.setState({ error: response.data.message, exporting: false })
                }else{
                    this.setState({ exportedFile: response.data.file, exporting: false })
                }
            })
            .catch((err) => {
                this.setState({ error: err.response.data.errors ? err.response.data.errors : err.response.data.message, exporting: false })
            })
        })
    }

    showData(){
        const { sort } = this.props;
        const { date_status, data } = this.state;

        if(sort === 'sku'){
            return (
                <Fragment>
                    <div className="chart_area_header">
                        <h2>Top Products - Times Purchased</h2>
                        <div>
                            <button className={"btn" + (date_status ? ' on' : '')}
                                onClick={() => this.toggleDateInputs()}
                            >{date_status ? 'Reset' : 'Filter By Date'}</button>
                            {date_status && 
                                <button className="btn export-btn" onClick={(e) => {
                                    if(this.state.exportedFile !== ""){
                                        e.preventDefault();
                                        window.location.href = '' + this.state.exportedFile;
                                    }
                                    else{
                                        this.exportData()
                                    }
                                }}>
                                {this.state.exporting ? 'Exporting...' : (this.state.exportedFile === "" ? 'Export' : 'Download')}
                                </button>}
                        </div>
                    </div>
                    {date_status ?
                    <div className="date-picker-row">
                        <input type="date" onChange={e => this.handleInputChange(e.target.value, 'start_date')}></input>
                        <input type="date" onChange={e => this.handleInputChange(e.target.value, 'end_date')}></input>
                    </div> : <Fragment></Fragment>
                    }
                    <table className="display_table light_table">
                        <thead>
                            <tr className="table-header">
                                <th></th>
                                <th>Sku</th>
                                <th className="right_aligned">Total Purchased</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isEmpty(data) ? <tr><td colSpan="3" style={{fontStyle: 'italic'}}>No results found for the selected date range.</td></tr> : 
                            Object.keys(data).map((key, index) =>
                                <tr key={key}>
                                    <td className="record-number">{index + 1}</td>
                                    <td data-id="Sku">{data[key].sku}</td>
                                    <td data-id="Times Purchased" className="right_aligned">{data[key].sku_count}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Fragment>
            )
        }else if(sort === 'revenue'){
            return (
                <Fragment>
                    <div className="chart_area_header">
                        <h2>Top Products - Total Purchased</h2>
                        <div>
                            <button className={"btn" + (date_status ? ' on' : '')}
                                onClick={() => this.toggleDateInputs()}
                            >{date_status ? 'Reset' : 'Filter By Date'}</button>
                            {date_status && 
                                <button className="btn export-btn" onClick={(e) => {
                                    if(this.state.exportedFile !== ""){
                                        e.preventDefault();
                                        window.location.href = '' + this.state.exportedFile;
                                    }
                                    else{
                                        this.exportData()
                                    }
                                }}>
                                {this.state.exporting ? 'Exporting...' : (this.state.exportedFile === "" ? 'Export' : 'Download')}
                                </button>
                            }
                        </div>
                    </div>
                    {date_status ?
                    <div className="date-picker-row">
                        <input type="date" onChange={e => this.handleInputChange(e.target.value, 'start_date')}></input>
                        <input type="date" onChange={e => this.handleInputChange(e.target.value, 'end_date')}></input>
                    </div> : <Fragment></Fragment>
                    }
                    <table className="display_table light_table">
                        <thead>
                            <tr className="table-header">
                                <th></th>
                                <th>Sku</th>
                                <th className="right_aligned">Total Purchased</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isEmpty(data) ? <tr><td colSpan="3" style={{fontStyle: 'italic'}}>No results found for the selected date range.</td></tr> : 
                            Object.keys(data).map((key, index) =>
                                <tr key={key}>
                                    <td className="record-number">{index + 1}</td>
                                    <td data-id="Sku">{data[key].sku}</td>
                                    <td data-id="Times Purchased" className="right_aligned"><NumberFormat value={data[key].total_price} displayType={'text'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={'$'} /></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Fragment>
            )
        }
    }

    render() {
        return (
            <div className="chart_area chart_1_2">
                {this.state.error && (
                    <div className="error">
                        {Object.keys(this.state.error).map(key => 
                            <span key={key}>{this.state.error[key]}</span>
                        )}
                    </div>
                )}
                {this.state.data && this.showData()}
            </div>
        )
    }
}

TopSellers.defaultProps = {
    sort: 'sku'
}

export default TopSellers



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/TopSellers.js